import { Calendar } from '@phosphor-icons/react';
import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';

const DateInput = ({
    label,
    isRequired,
    isEditable,
    attributes,
}: {
    label: string;
    isRequired: boolean;
    isEditable: boolean;
    attributes: { [key: string]: string };
}) => {
    return (
        <div data-testid="component-preview-input" className="component-preview-input">
            <PreviewComponentLabel labelText={label} isRequired={isRequired} />
            <input
                tabIndex={-1}
                type={attributes?.['$isSlider'] === 'true' ? 'range' : 'text'}
                disabled={!isEditable}
            />
            <Calendar
                data-testid="component-preview-calendar-icon"
                className="component-preview-calendar-icon"
                weight="thin"
                size={30}
            />
        </div>
    );
};

export default DateInput;
